<script>
import { mapGetters } from 'vuex'
import { AllRoutes } from '@/router.js';
import NavbarBase from 'firepuma-vue-axios-vuex-extensions/vuex-navbar/NavbarBase.vue';
import AdminAlertsLoader from '@/broilerAdmin/components/AdminAlertsLoader.vue';

export default {
  components: {
    NavbarBase,
    AdminAlertsLoader,
  },

  filters: {
    snakeToTitleCase(str) {
      if (!str) return str;
      return str.replace('_', ' ').replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
  },

  data: () => ({
    defaultRoles: ['BroilerAdmin', 'LayerAdmin', 'Broilers', 'Layers'],
    allRoutes: AllRoutes,
  }),

  computed: {
    ...mapGetters(['shortAppName']),
    ...mapGetters('auth', ['userExtra']),
  },
};
</script>

<template>
  <navbar-base
    :default-roles="defaultRoles"
    :app-name="shortAppName"
    logo-image-url="/static/img/logo-512x512.png"
    :all-routes="allRoutes"
    class="navbar navbar-expand-lg sticky-top mb-2 navbar-light bg-light">

    <span slot="left-of-navbar-toggler-icon">
      <admin-alerts-loader class="d-inline">
        <i slot-scope="{hasAlerts}" v-if="hasAlerts" class="fa fa-bell text-info"></i>
      </admin-alerts-loader>
    </span>

    <span slot="left-of-dropdown-fullname">
      <admin-alerts-loader class="d-inline">
        <i slot-scope="{hasAlerts}" v-if="hasAlerts" class="fa fa-bell text-info"></i>
      </admin-alerts-loader>
    </span>

    <!-- <span slot="below-profile-dropdown-item">
      <admin-alerts-loader class="d-inline">
        <template slot-scope="{hasAlerts, alertsRoute, alerts}" v-if="hasAlerts">
          <div class="dropdown-divider"></div>
          <router-link :to="alertsRoute" class="dropdown-item">
            <i class="fa fa-bell text-info"></i>
            Admin Alerts ({{alerts.length}})
          </router-link>
        </template>
      </admin-alerts-loader>
    </span> -->

    <span slot="above-logout-dropdown-item">

      <div class="dropdown-divider"></div>
      <router-link :to="{name: 'feedback'}" class="dropdown-item">
        <i class="fa fa-smile-o text-muted"></i>
        Give Feedback
      </router-link>

      <template v-if="userExtra.user_tenant">
        <div class="dropdown-divider"></div>
        <router-link :to="{name: 'tenant/overview'}" class="dropdown-item text-muted">
          Tenant: {{userExtra.user_tenant | snakeToTitleCase}}
        </router-link>
      </template>
    </span>

  </navbar-base>
</template>



// WEBPACK FOOTER //
// src/Navbar.vue